module.exports = __webpack_public_path__ + "img/fl-icon-active.4f1d18eb.svg";